import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "body2-text brg-color-grey-600" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createCommentVNode(" 본사상담 버튼 "),
        (_ctx.policy.isCustomerSupportAvailable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t(_ctx.lc + 'customer_support_description')), 1 /* TEXT */),
                _createVNode(_component_v_btn, {
                    text: "",
                    class: "px-3 text-subtitle-2 text-black",
                    onClick: _ctx.handleClickOpenGitple
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'customer_support')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
            ]))
            : _createCommentVNode("v-if", true)
    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */));
}
